import {
  UNVALIDATED_COURSES_LOAD,
  UNVALIDATED_COURSES_LOADING,
  UNVALIDATED_COURSES_ERROR,
  UNVALIDATED_COURSES_CLEAR,
} from '../actions/types';

const initialState = {
  loading: false,
  unvalidatedCourses: [],
  reprises: [],
  reprisesTotal: 0,
  academicYear: null,
  hasValidMeans: false,
  serialNum: null,
  total: 0,
  error: null,
};

/**
 * Reducer for unvalidated courses state
 * Manages loading, error, and data states
 */
export default function unvalidatedCourses(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case UNVALIDATED_COURSES_LOADING:
      return { ...state, loading: true, error: null };
    case UNVALIDATED_COURSES_LOAD:
      return {
        ...state,
        unvalidatedCourses: payload.unvalidatedCourses || [],
        reprises: payload.reprises || [],
        reprisesTotal: payload.reprisesTotal || 0,
        academicYear: payload.academicYear || null,
        hasValidMeans: payload.hasValidMeans || false,
        serialNum: payload.serialNum || null,
        total: payload.total || 0,
        loading: false,
        error: null,
      };
    case UNVALIDATED_COURSES_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    case UNVALIDATED_COURSES_CLEAR:
      return initialState;
    default:
      return state;
  }
}
